import React from "react";

const returnMenu = props => {
  var myStyle = {
    position: "absolute",
    top: `${props.contextMenu.y}px`,
    left: `${props.contextMenu.x - 430}px`
  };

  return (
    <div className="custom-context" id="customcontext" style={myStyle}>
      {props.contextMenu.menu.map((item, index, arr) => {
        if (arr.length - 1 === index) {
          return (
            <div
              key={index}
              id={index}
              className="custom-context-item-last"
              onClick={props.onSubmit}
            >
              {item.label}
            </div>
          );
        } else {
          return (
            <div
              key={index}
              id={index}
              className="custom-context-item"
              onClick={props.onSubmit}
            >
              {item.label}
            </div>
          );
        }
      })}
    </div>
  );
};

const CustomContext = props => {
  return (
    <div id="contextmenu">
      {props.contextMenu.visible ? returnMenu(props) : null}
    </div>
  );
};

export default CustomContext;
